<template>
    <div
        class="more-comment"
        @click="clickItem"
    >{{ status == 0 ? '暂时还没有人评论' : status == 1 ? '查看更多评论' : '已经加载全部评论了' }}</div>
</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "layout-more",
    mixins: [mixin],
    props: {
        status: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style scoped src="./style.css"></style>
